import { Component, OnInit, Input, OnChanges, signal, computed } from '@angular/core';
import { ConfigSchema } from '../../../models/config-schema.model';
import { FlowObjectInstance } from '../../../models/flow-object.model';
import { OutputDataTaskGatewayRules } from '../../../models/input-output-data.model';
import { Utils } from '../../../shared/utils';
import { IMPORTS } from './_imports';

@Component({
    selector: 'fob-gateway-rules',
    templateUrl: './fob-gateway-rules.component.html',
    styleUrl: './fob-gateway-rules.component.scss',
    standalone: true,
    imports: IMPORTS
})

export class FlowObjectGatewayRulesComponent implements OnInit, OnChanges {
    // #region [Type props]
    Utils = Utils;
    // #endregion

    // #region [signals]
    $model = signal(null as FlowObjectInstance);
    // #endregion

    // #region [computeds]
    $outputData = computed(() => JSON.parse(this.$model()?.outputData) as OutputDataTaskGatewayRules);
    $configSchema = computed(() => JSON.parse(this.$model().flowObjectDefinition.configSchema) as ConfigSchema);
    // #endregion

    // #region [Input/Output]
    @Input() _model: FlowObjectInstance;
    // #endregion

    constructor() { }

    ngOnInit() { }

    ngOnChanges() {
        this.$model.set(this._model);
    }

    // #region [===== private methods =====]
    // #endregion
}
